import { map } from 'lodash';

export const getTypingUsers = state => state.typing;
export const getTypingUserIds = state => map(getTypingUsers(state), user => user.siteMemberId);
